import { lazy } from "react";
import { Navigate } from "react-router-dom";
import { PATHS, registerRoutePreloader } from "@/lib/router";
import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";

// Named so the sidebar can warm the same chunk on hover/focus (see
// routePreload.js) — the very first navigation to this feature in a
// session otherwise always pays for the lazy import's network fetch inside
// the Suspense fallback, which reads as the page taking a moment to load
// instead of switching instantly.
const importDataEntryPage = () => import("./pages/DataEntryPage");
const importDataEntryOverviewPage = () =>
  import("./pages/DataEntryOverviewPage");
const importKpiDashboardPage = () => import("./pages/KpiDashboardPage");

const DataEntryPage = lazy(importDataEntryPage);
const DataEntryOverviewPage = lazy(importDataEntryOverviewPage);
const KpiDashboardPage = lazy(importKpiDashboardPage);

registerRoutePreloader(PATHS.DATA_ENTRY, importDataEntryPage);
registerRoutePreloader(PATHS.DATA_ENTRY_OVERVIEW, importDataEntryOverviewPage);
registerRoutePreloader(PATHS.DATA_ENTRY_DASHBOARD, importKpiDashboardPage);

const withDataEntryProvider = (element) => (
  <FeatureProvider namespace={Feature_NAMESPACES.DATA_ENTRY}>
    {element}
  </FeatureProvider>
);

export const dataEntryRoutes = [
  {
    path: PATHS.DATA_ENTRY_DASHBOARD,
    element: withDataEntryProvider(<KpiDashboardPage />),
    handle: { permission: { resource: "esg_data_entry", action: "view" } },
  },
  {
    path: PATHS.DATA_ENTRY_OVERVIEW,
    element: withDataEntryProvider(<DataEntryOverviewPage />),
    handle: { permission: { resource: "esg_data_entry", action: "view" } },
  },
  {
    // Legacy route — Consolidated is now a switch on the Overview page.
    path: PATHS.DATA_ENTRY_CONSOLIDATED,
    element: (
      <Navigate to={`${PATHS.DATA_ENTRY_OVERVIEW}?view=consolidated`} replace />
    ),
    handle: { permission: { resource: "esg_data_entry", action: "view" } },
  },
  {
    path: PATHS.DATA_ENTRY,
    element: withDataEntryProvider(<DataEntryPage />),
    handle: { permission: { resource: "esg_data_entry", action: "view" } },
  },
];
